import { NOT_APPLICABLE } from 'constants/defaultValues';

import { getString } from 'strings/translation';
import { SamplingHistorySummaryType } from 'store/samplingHistory/types';

export const getSampleHistoryRowData = (samplingHistoryList: SamplingHistorySummaryType[]) =>
  samplingHistoryList.reduce(
    (rowData, planSummary) => {
      const planAcres = Math.ceil(
        planSummary.point_sample_count > 0 ? planSummary.field_acres : planSummary.sampled_area,
      );
      return {
        sampledArea: rowData.sampledArea + planAcres,
        zoneSamples: rowData.zoneSamples + planSummary.zone_sample_count,
        pointSamples: rowData.pointSamples + planSummary.point_sample_count,
        shippedSamples: rowData.shippedSamples + planSummary.shipped_sample_count,
        arrivedSamples: rowData.arrivedSamples + planSummary.arrived_sample_count,
        isEMI: rowData.isEMI || planSummary.emi_scan,
        isADCP: rowData.isADCP || planSummary.adcp_measurement,
        isArrived: rowData.isArrived || planSummary.arrived_sample_count > 0,
      };
    },
    {
      sampledArea: 0,
      zoneSamples: 0,
      pointSamples: 0,
      shippedSamples: 0,
      arrivedSamples: 0,
      isEMI: null,
      isADCP: null,
      isArrived: false,
    } as {
      sampledArea: number;
      zoneSamples: number;
      pointSamples: number;
      shippedSamples: number;
      arrivedSamples: number;
      isEMI: boolean | null;
      isADCP: boolean | null;
      isArrived: boolean;
    },
  );

export const getDisplayForIsEMIADCP = (isEMIADCP: boolean | null, language: string) => {
  if (isEMIADCP === null) {
    return NOT_APPLICABLE;
  }
  return getString(isEMIADCP ? 'yes' : 'no', language);
};

export const getHistoryByOperation = (samplingHistoryList: SamplingHistorySummaryType[]) => {
  const fieldsByOperation = Object.values(
    samplingHistoryList.reduce(
      (dict, field) => {
        if (!dict[field.operation_id]) {
          dict[field.operation_id] = {
            id: field.operation_id,
            name: field.operation_name,
            fields: [],
          };
        }

        dict[field.operation_id].fields.push(field);
        return dict;
      },
      {} as { [id: number]: { id: number; name: string; fields: SamplingHistorySummaryType[] } },
    ),
  );

  return fieldsByOperation;
};
